import React from 'react'
import SanityImage from 'gatsby-plugin-sanity-image'
import { IntegrationsCopy, IntegrationsLogo } from '../Grids/Grid.styles'
import IntegrationsContainer from '../Integration/IntegrationsContainer'


export default function CardContainer({ connector }) {
	const { title, illustration, tool } = connector

	return (
		<>
			{tool ? (
				<IntegrationsContainer connector={connector} key={connector._key} />
			) : (
				<>
					{illustration ? (
						<>
							{illustration.image.asset ? (
								<IntegrationsLogo>
									<SanityImage
										asset={illustration.image.asset}
										alt={illustration.image.alt}
										{...illustration}
									/>
								</IntegrationsLogo>
							) : null}
						</>
					) : null}
					<IntegrationsCopy>
						<h2>{title}</h2>
					</IntegrationsCopy>
				</>
			)}
		</>
	)
}
